import React, { FunctionComponent } from 'react';
import Styles from './ImageMagnifier.module.scss';

interface ImageMagnifierProps {
  src: string;
  alt: string;
  caption?: string;
  className?: string;
}

const ImageMagnifier: FunctionComponent<ImageMagnifierProps> = ({ 
  src, 
  alt, 
  caption, 
  className = '' 
}) => {
  return (
    <div className={`${Styles.imageContainer} ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={Styles.image}
      />
      
      {caption && (
        <p className={Styles.caption}>
          {caption}
        </p>
      )}
    </div>
  );
};

export default ImageMagnifier;